import { forwardRef } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

type AlertProps = {
  text: string;
  title?: string;
  color?: 'dark' | 'red' | 'yellow';
  className?: string;
};

export type RefAlert = HTMLDivElement;

export const Alert = forwardRef<RefAlert, AlertProps>(
  ({ text, title, color = 'dark', className, ...props }, ref) => (
    <Container className={`${className} ${color}`} {...props} ref={ref}>
      <IconStyled name="warning-circle" size="s20" />
      <Content>
        {title && <Title>{title}</Title>}
        <span>{text}</span>
      </Content>
    </Container>
  ),
);

Alert.displayName = 'Alert';

const Container = styled.div`
  --iwa-border: ${COLORS.systemDark100};
  --iwa-color: ${COLORS.systemDark300};
  --iwa-background: ${COLORS.systemLight200};
  --iwa-icon-color: ${COLORS.systemDark200};

  &&&.red {
    --iwa-border: ${COLORS.systemFlame200};
    --iwa-color: ${COLORS.systemDark300};
    --iwa-background: ${COLORS.systemFlame100};
    --iwa-icon-color: ${COLORS.systemFlame200};
  }

  &&&.yellow {
    --iwa-border: ${COLORS.systemSun200};
    --iwa-color: ${COLORS.systemDark300};
    --iwa-background: ${COLORS.systemSun100};
    --iwa-icon-color: ${COLORS.systemSun200};
  }

  padding: 12px;
  min-height: 44px;
  border: 1px solid var(--iwa-border);
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--iwa-color);
  background: var(--iwa-background);
`;

const IconStyled = styled(Icon)`
  color: var(--iwa-icon-color);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  font-weight: 700;
`;
